import { FormattedMessage, useIntl } from 'react-intl';
import React, { useContext } from 'react';
import { useModal } from 'store/modals';
import { useDisableUser } from 'services/admin/disable-user';
import { Icon } from 'semantic-ui-react';
import { Button } from 'components/form-elements/buttons/Button';
import { Text } from 'components/typography';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';
import styles from './styles.module.scss';

export const DisableUser = () => {
  const { openModal } = useModal();
  const { selectedUser, setSelectedUser } = useContext(UserAdministrationModalContext);
  const intl = useIntl();

  const { disableUserAsync } = useDisableUser({
    onSuccess: () => {
      setSelectedUser(null);
    },
  });

  function onDisableUser() {
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        type: 'warning',
        title: intl.formatMessage({
          id: 'disableUser',
        }),
        content: intl.formatMessage({
          id: 'disableUserWarning',
        }),
        onConfirm: () => disableUserAsync(selectedUser.id),
        onCancel: () => setSelectedUser(false),
      },
    });
  }

  return (
    <Button
      type="button"
      className={styles.disableBtn}
      onClick={() => {
        onDisableUser();
      }}
    >
      <div className={styles.disableBtnContent}>
        <Icon
          name="ban"
          size="large"
        />
        <Text
          underline
          medium
        >
          <FormattedMessage id="disableUser" />
        </Text>
      </div>
    </Button>

  );
};
